import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import {
  FleetControl,
  VehicleProvider,
  VehicleControl,
} from "../context/FleetContext";
import { NotificationContainer } from "../components/Notification/NotificationContainer";
import { CircularProgress } from "@material-ui/core";
// pages
import Error from "../pages/error";
import Login from "../pages/login";

// context
import { useUserState } from "../context/UserContext";
import { Suspense } from "react";

export default function App() {
  // global
  var { isAuthenticated } = useUserState();

  return (
    <Suspense fallback={<CircularProgress size={20} style={{ marginTop: "14px" }} />}>
      <HashRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/app/trips" />} />
          <PublicRoute path="/login" component={Login} />
          <Route
            exact
            path="/app"
            render={() => <Redirect to="/app/trips" />}
          />
          <VehicleProvider>
            <VehicleControl />
            <PrivateRoute path="/app" component={React.lazy(() => import('./Layout'))} />
          </VehicleProvider>
          <Route component={Error} />
        </Switch>
      </HashRouter>
      <NotificationContainer />
      <FleetControl />
    </Suspense>
      
      
  );

  // #######################################################################

  /**
   * If the user is not authenticated, go to login
   */
  function PrivateRoute({ component, ...rest }) {
    const render = props => {
      const redirectTo = {
        pathname: "/login",
        state: { from: props.location },
      };
      return isAuthenticated ? (
        React.createElement(component, props)
      ) : (
        <Redirect to={redirectTo} />
      );
    };
    return <Route {...rest} render={render} />;
  }

  /**
   * If the user is not authenticated, show <Login/>;
   * otherwise go to "/"
   */
  function PublicRoute({ component, ...rest }) {
    const render = props => {
      if (isAuthenticated) {
        return <Redirect to={{ pathname: "/" }} />;
      }
      return React.createElement(component, props);
    };
    return <Route {...rest} render={render} />;
  }
}
